// extracted by mini-css-extract-plugin
module.exports = {"loadingAnimation":"Loading_loadingAnimation__13iep"};